import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

interface AppTile {
  name: string;
  image: string;
}

@Component({
  selector: 'app-pricing-modules',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pricing-modules.html',
  styleUrls: ['./pricing-modules.css'],
})
export class PricingModulesComponent {
  readonly coreModules: AppTile[] = [
    { name: 'Human Resource',  image: 'images/webps/hr.svg'            },
    { name: 'CRM',             image: 'images/webps/crm.svg'           },
    { name: 'Sales',           image: 'images/webps/sales.svg'         },
    { name: 'Inventory',       image: 'images/webps/inventory.svg'     },
    { name: 'Accounting',      image: 'images/webps/accounting.svg'    },
    { name: 'Procurement',     image: 'images/webps/procurement.svg'   },
    { name: 'Manufacturing',   image: 'images/webps/manufacturing.svg' },
  ];

}
